export const experienceData = [
    {
        id: 1,
        company: 'Menefex',
        jobtitle: 'Senior Frontend Developer',
        startYear: 'Dec 2021',
        endYear: 'Nov 2022'
    },
    {
        id: 2,
        company: 'Port Zero',
        jobtitle: 'Senior Frontend Developer',
        startYear: 'Aug 2019',
        endYear: 'Jun 2020'
    },
    {
        id: 3,
        company: 'E-Sea',
        jobtitle: 'Junior Frontend Developer',
        startYear: 'Aug 2017',
        endYear: 'May 2019'
    },
]